import { render } from "./ExtranetDashboard.vue?vue&type=template&id=af334f02&scoped=true"
import script from "./ExtranetDashboard.vue?vue&type=script&lang=js"
export * from "./ExtranetDashboard.vue?vue&type=script&lang=js"

import "./ExtranetDashboard.vue?vue&type=style&index=0&id=af334f02&scoped=true&lang=css"

import exportComponent from "/home/forge/mymembership.id/releases/81403580/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-af334f02"]])

export default __exports__